import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./font-files/roboto-mono-greek-normal-23a1a297.woff2%22,%22weight%22:%22100%20700%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22preload%22:false,%22adjustFontFallback%22:false,%22declarations%22:[{%22prop%22:%22font-family%22,%22value%22:%22figure%22},{%22prop%22:%22unicode-range%22,%22value%22:%22U+0370-0377,%20U+037A-037F,%20U+0384-038A,%20U+038C,%20U+038E-03A1,%20U+03A3-03FF%22}]}],%22variableName%22:%22figureGreek%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'figureGreek'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
